<template>
  <div
    class="popup text-white grid grid-cols-2 place-content-center h-[100vh]"
    :class="{ active: isActive }"
  >
    <div class="top-bar col-span-2">
      <span class="close-btn" @click="$emit('close')"></span>
    </div>
    <div
      class="
        layout-padding
        col-span-2
        lg:col-span-1
        text-section-popup
        flex flex-col
        justify-center
      "
    >
      <div class="image-name font-bold text-xl">{{ title }}</div>
      <div class="my-5 font-bold">{{ year }}</div>
      <div class="" v-html="description"></div>
    </div>
    <div class="col-span-2 lg:col-span-1">
      <div class="w-full writing-img" :style="`background:url(${img})`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isActive", "title", "img", "description", "year"],
  emits: ["close"],
};
</script>
<style scoped>
/* popup */

.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 101vw;
  height: 101vh;
  background: rgba(0, 0, 0, 0.85);

  z-index: 100;
  overflow: hidden;
  transition: 1s;
  opacity: 0;
}

.popup.active {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

.popup.active .close-btn,
.popup.active .image-name,
.popup.active .index,
.popup.active .large-image,
.popup.active .arrow-btn {
  opacity: 1;
  transition: opacity 0.5s;
  transition-delay: 1s;
}

.top-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #000;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-weight: 300;
}

.image-name {
  opacity: 0;
}

.close-btn {
  opacity: 0;
  position: absolute;
  top: 15px;
  right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f00;
  cursor: pointer;
}

.arrow-btn {
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  border-radius: 50%;
  border: none;
  background: none;
  cursor: pointer;
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
  transform: translateY(-50%) rotate(180deg);
}

.arrow-btn:hover {
  background: rgba(0, 0, 0, 0.5);
}

.index {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 80px;
  font-weight: 100;
  color: rgba(255, 255, 255, 0.4);
  opacity: 0;
}

.writing-img {
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-color: #fff !important;
  height: calc(100vh - 50px);
  margin-top: 50px;
}
.text-section-popup {
  height: calc(100vh - 50px);
}

@media (max-width: 1024px) {
  .writing-img {
    height: 50vh;
    margin-top: 0px;
  }
  .text-section-popup {
    height: calc(50vh - 50px);
    margin-top: 50px;
  }
}
</style>